import { GET_MASTER_DATA, GET_MASTER_DATA_TABLE } from './types'

const initialState = {
  masterData: [],
  masterDataTable: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MASTER_DATA:
      return {
        ...state,
        masterData: action.payload,
      }
    case GET_MASTER_DATA_TABLE:
      return {
        ...state,
        masterDataTable: action.payload,
      }
    default:
      return state
  }
}
